export function generateId(){
  let value = Math.floor(Math.random() * 100000)
  try{
    value = crypto.randomUUID()
  }catch(e){
  }
  return value
}